var _style, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 30.8",
    style: {
      enableBackground: "new 0 0 31 30.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M18.1,17.7C18.1,17.7,18.1,17.7,18.1,17.7C18.1,17.7,18.1,17.7,18.1,17.7c-1.4,1.4-3.2,2.1-5.1,2.1 c-1.9,0-3.8-0.8-5.1-2.1c-1.4-1.4-2.1-3.2-2.1-5.1c0-1.9,0.8-3.8,2.1-5.1c1.4-1.4,3.2-2.1,5.1-2.1c1.9,0,3.8,0.8,5.1,2.1 c1.4,1.4,2.1,3.2,2.1,5.1C20.2,14.5,19.5,16.4,18.1,17.7L18.1,17.7z M19,6.5C17.4,4.9,15.2,4,12.9,4c-2.3,0-4.4,0.9-6.1,2.5 c-1.6,1.6-2.5,3.8-2.5,6.1s0.9,4.4,2.5,6.1c1.6,1.6,3.8,2.5,6.1,2.5c2.1,0,4-0.7,5.6-2.1l7.7,7.7c0.1,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-0.9l-7.7-7.7c1.3-1.6,2.1-3.5,2.1-5.6C21.5,10.3,20.6,8.2,19,6.5L19,6.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034053729312023876550000012241903583245263796_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 3,
    style: {
      clipPath: "url(#SVGID_00000034053729312023876550000012241903583245263796_)"
    },
    fill: "#808E8E",
    width: 25,
    height: 25
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000064329113263363465400000000559962808593809329_",
    d: "M17.2,12h-3.6V8.3c0-0.4-0.3-0.6-0.6-0.6 c-0.4,0-0.6,0.3-0.6,0.6V12H8.6C8.3,12,8,12.2,8,12.6s0.3,0.6,0.6,0.6h3.6v3.6c0,0.4,0.3,0.6,0.6,0.6c0.4,0,0.6-0.3,0.6-0.6v-3.6 h3.6c0.4,0,0.6-0.3,0.6-0.6S17.6,12,17.2,12L17.2,12z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078726274508248173510000016342204225323744171_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064329113263363465400000000559962808593809329_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.7,
    style: {
      clipPath: "url(#SVGID_00000078726274508248173510000016342204225323744171_)"
    },
    fill: "#808E8E",
    width: 11.9,
    height: 11.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomin);
export default __webpack_public_path__ + "static/media/zoomin.f46a4c7c3d09528c6209da708eb1e8f0.svg";
export { ForwardRef as ReactComponent };